export const GA_TRACKING_ID = "UA-95892-1";
export const COMMENTS_PER_PAGE = 30;
export const ARTIST_TRACKS_PER_PAGE = 42;
export const GENRE_TRACKS_PER_PAGE = 9;
export const ARCHIVE_TRACKS_PER_PAGE = 24;
